import { httpClient, httpClientUrlStringBuilder } from '@/network/clientController'

/** List of steps and their status
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_customerscreationprocessSteps
*/
export const getStepsListInfo = payload => {
    return httpClient({
        method: 'GET',
        url: 'customers/creation/processSteps',
        params: payload
    })
}

/** Start create account process
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_customerscreation
*/
export const startCreateAccountProcess = payload => {
	return httpClient({
		method: 'POST',
		url: 'customers/creation',
		data: payload
	})
}

/** Send valitation OTP
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_customerscreationsendValidationOTP
*/
export const sendValitationOTP = payload => {
	return httpClient({
		method: 'POST',
		url: 'customers/creation/sendValidationOTP',
		params: payload
	})
}

/** Resend valitation OTP
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_customerscreationresendValidationOTP
*/
export const resendValitationOTP = payload => {
	return httpClient({
		method: 'POST',
		url: 'customers/creation/reSendValidationOTP',
		params: payload
	})
}

/** Validate OTP
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_customerscreationvalidateOTP
*/
export const validateOTP = payload => {
	return httpClient({
		method: 'POST',
		url: 'customers/creation/validateOTP',
		/*
		* Since the structure of this is values comming in one object,
		* as default from token modal, we are separating the params here
		*/
		params: { processId: payload.processId },
		data: {
			response: payload.response,
			shouldValidateExistingProcesses: payload.shouldValidateExistingProcesses
		}
	})
}

/** Request Uploaded Document
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_customerscreationdocument
*/
export const requestUploadedDocument = payload => {
	return httpClientUrlStringBuilder({
		method: 'GET',
		url: 'customers/creation/document',
		params: payload
	})
}

/** Create Document
@docs Não há DOC `customers/creation/document?processId=${this.processId}&documentType={back ou front}`
*/
export const createDocument = payload => {
	return httpClient({
		method: 'POST',
		url: 'customers/creation/document',
		params: payload.params,
		data: payload.data
	})
}

/** Delete Document
@docs Não há DOC `customers/creation/document?processId=${this.processId}&documentType={back ou front}`
*/
export const deleteDocument = payload => {
	return httpClient({
		method: 'DELETE',
		url: 'customers/creation/document',
		params: payload.params
	})
}

/** Uploads Supporting Document
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_customerscreationsupportingDocument
*/
export const uploadSupportingDocument = payload => {
	return httpClient({
		method: 'POST',
		url: 'customers/creation/supportingDocument',
		params: payload.params,
		data: payload.data
	})
}

/** Process documents and get their info
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_customerscreationprocessDocuments
*/
export const processDocumentsInfo = payload => {
	return httpClient({
		method: 'POST',
		url: 'customers/creation/processDocuments',
		params: payload
	})
}

/** Update Create Account Process info
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_customerscreationupdateprocess
*/
export const updateCreateAccountProcessInfo = payload => {
	return httpClient({
		method: 'POST',
		url: 'customers/creation/update/process',
		data: payload
	})
}

/** validateDocument
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_customerscreationvalidateDocument
*/
export const validateDocument = payload => {
	return httpClient({
		method: 'POST',
		url: 'customers/creation/validateDocument',
		params: payload
	})
}

/** List of literary abilities
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_customercreationlovsliteraryAbilities
*/
export const getLiteraryAbilities = () => {
    return httpClient({
        method: 'GET',
        url: 'customers/creation/lovs/literaryAbilities'
    })
}

/** List of occupations
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_customercreationlovsprocessOccupation
*/
export const getProcessOccupation = () => {
    return httpClient({
        method: 'GET',
        url: 'customers/creation/lovs/processOccupation'
    })
}

/** List of MaritalStatus
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_customercreationlovsmaritalStatus
*/
export const getMaritalStatus = () => {
    return httpClient({
        method: 'GET',
        url: 'customers/creation/lovs/maritalStatus'
    })
}

/** List of countries
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_customercreationlovscountries
*/
export const getCountries = () => {
    return httpClient({
        method: 'GET',
        url: 'customers/creation/lovs/countries'
    })
}

/** List of provinces
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_customercreationlovsprovinces
*/
export const getProvinces = () => {
    return httpClient({
        method: 'GET',
        url: 'customers/creation/lovs/provinces'
    })
}

/** List of counties
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_customerscreationlovscounties
*/
export const getCounties = payload => {
    return httpClient({
        method: 'GET',
        url: 'customers/creation/lovs/counties',
		params: payload
    })
}

/** List of professions
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_customercreationlovsprofessions
*/
export const getProfessions = () => {
    return httpClient({
        method: 'GET',
        url: 'customers/creation/lovs/professions'
    })
}

/** List of professional activities
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_customercreationlovsprofessionalActivities
*/
export const getProfessionalActivities = () => {
    return httpClient({
        method: 'GET',
        url: 'customers/creation/lovs/professionalActivities'
    })
}

/** List of contractualTies
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_customerscreationlovscontractualTies
*/
export const getContractualTies = () => {
    return httpClient({
        method: 'GET',
        url: 'customers/creation/lovs/contractualTies'
    })
}

/** List of branches
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_customerscreationbranchList
*/
export const getBranchList = payload => {
    return httpClient({
        method: 'GET',
        url: 'customers/creation/lovs/branches',
        params: payload
    })
}

/** Submit interview video
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POSTinternetcompanycustomerscreationinterview
* wiki is for company api, but it's the same
*/
export const submitInterviewVideo = payload => {
	return httpClient({
		method: 'uploadFile',
		url: 'customers/creation/interview',
		params: payload.params,
        filePath: payload.filePath,
        fileName: payload.fileName
	})
}

/** Delete submited interview video
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/DELETEinternetcompanycustomerscreationinterview
*/
export const deleteSubmitedInterviewVideo = payload => {
    return httpClient({
        method: 'DELETE',
        url: 'customers/creation/interview',
        params: payload.params
    })
}

/** Submit Final Step for Account Process info
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_customerscreationfinalStepsubmit
*/
export const submitCreateAccountProcessInfo = payload => {
	return httpClient({
		method: 'POST',
		url: 'customers/creation/finalStep/submit',
        params: payload.params,
		data: payload.data
	})
}

/** Resend Password
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_customerscreationresendpassword
*/
export const resendPassword = payload => {
	return httpClient({
		method: 'POST',
		url: 'customers/creation/resend/password',
		data: payload
	})
}
